let appHost = import.meta.env.APP_HOST;

if (!appHost && import.meta.env.HEROKU_APP_DEFAULT_DOMAIN_NAME) {
  appHost = `https://${import.meta.env.HEROKU_APP_DEFAULT_DOMAIN_NAME}`;
}

export const APP_HOST = appHost;
export const BUDGET_LIMIT = parseFloat(import.meta.env.MAX_BUDGET_LIMIT, 10);
export const SUPPORT_EMAIL = import.meta.env.SUPPORT_EMAIL || 'support@hubstaff.com';

export const RELEASE_NAME = import.meta.env.RELEASE_NAME || window.SENTRY_RELEASE_NAME;
export const SENTRY_ENABLED = import.meta.env.SENTRY_ENABLED === 'true';
export const SENTRY_ENVIRONMENT = import.meta.env.SENTRY_ENVIRONMENT;
export const SENTRY_DSN = import.meta.env.SENTRY_DSN;
export const SENTRY_SAMPLE_RATE = parseInt(import.meta.env.SENTRY_SAMPLE_RATE, 10);
export const SENTRY_TRACES_SAMPLE_RATE = parseInt(import.meta.env.SENTRY_TRACES_SAMPLE_RATE, 10);
